/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type BulkSelectionMode = typeof BulkSelectionMode[keyof typeof BulkSelectionMode];


export const BulkSelectionMode = {
  all: 'all',
  include: 'include',
  range: 'range',
} as const;
